<template>
  <div v-click-outside="() => (isOpenLoginMenu = false)" class="relative">
    <button
      @click="handleLoginTypeMenu"
      class="w-[max-content] group flex justify-center bg-[initial] xl:p-0 items-center h-[32px] md:h-[44px] hover:text-secondary rounded-[5px] p-1 xl:min-w-[120px]"
      :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
    >
      <div class="md:flex justify-center w-[24px] h-[24px] md:w-[32px] md:h-[32px]">
        <icon-profile
          class="group-active:text-secondary-pressed group-hover:text-secondary text-[#242D21]"
          :class="{ 'text-secondary-pressed': isOpenLoginMenu }"
        />
      </div>
      <span
        class="text-[18px] font-medium font-Montserrat hidden xl:block group-active:text-secondary-pressed group-hover:text-secondary"
        >{{ $t("common.login") }}</span
      >
      <icon-arrow-list
        class="hidden xl:block ml-2 w-[12px] h-[12px]"
        :class="{
          'rotate-180': isOpenLoginMenu,
        }"
      />
    </button>
    <div
      v-show="isOpenLoginMenu"
      class="absolute xl:left-0 left-auto right-0 xl:right-auto xl:top-[100%] top-[105%] bg-white z-[99999] py-[12px] px-4 border-secondary border-[2px] rounded-[0.625rem] flex flex-col gap-2"
    >
      <button
        v-for="loginType in loginTypes"
        :key="loginType.label"
        @click="gotoLogin"
        class="w-[max-content] gap-[8px] flex items-center text-black group leading-none"
        :data-type="loginType.value"
      >
        <component :is="loginType.icon" class="group-hover:text-secondary-hover w-6 h-6" />
        <span :data-type="loginType.value" class="shrink-0 xl:text-[18px] text-[16px] underline group-hover:text-secondary-hover">{{
          $t(loginType.label)
        }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MANAGER_URL } from "@/api/urls"
import { ref } from "vue"
import { useRouter } from "vue-router"

import { useVendorOpen } from "composables/useVendorOpen"

import IconManagerAcc from "components/icons/IconManagerAcc.vue"
import IconProfile from "components/icons/IconProfile.vue"
import IconVendorAcc from "components/icons/IconVendorAcc.vue"

const loginTypes = [
  {
    value: "vendor",
    label: "common.vendor",
    icon: IconVendorAcc,
  },
  {
    value: "manager",
    label: "common.partner",
    icon: IconManagerAcc,
  },
]

const router = useRouter()
const { gotoLoginPage } = useVendorOpen()

const isOpenLoginMenu = ref(false)

const handleLoginTypeMenu = (): void => {
  isOpenLoginMenu.value = !isOpenLoginMenu.value
}

const gotoLogin = ({ target }: { target: HTMLElement }) => {
  const { type } = target.dataset
  switch (type) {
    case "current":
      router.push({ name: "/profile/details/account" })
      break
    case "vendor":
      gotoLoginPage()
      break
    case "manager":
      window.open(`${MANAGER_URL}/login`)
      break
    default:
      return false
  }
}
</script>
